import otherData from "./Guides/OtherGuides";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const OtherGuides = () => {
  return <GuideRenderer url="endgame" guideData={otherData} />;
};

export default OtherGuides;
